export default {
  apiKey: 'AIzaSyDzrtcZIbBR6HIE_UjCuiEsLZ__lOsa678',
  authDomain: 'secnotes-6e22d.firebaseapp.com',
  databaseURL: 'https://secnotes-6e22d.firebaseio.com',
  projectId: 'secnotes-6e22d',
  storageBucket: '',
  messagingSenderId: '267457482558'
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js